import { Component, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogPdfComponent {

  page: number = 1;
  rotation: number = 0;
  zoom: number = 1.0;
  originalSize: boolean = false;
  pdf: any;
  renderText: boolean = false;
  isLoaded: boolean = false;
  stickToPage = false;
  showAll: boolean = false;
  autoresize: boolean = true;
  fitToPage: boolean = false;
  
  pdfSrc: string = '';
  constructor(public dialogRef: MatDialogRef<DialogPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      console.log(data);
      this.pdfSrc = data.url;
  }

  incrementPage(amount: number) {

    this.page += amount;

  }

  incrementZoom(amount: number) {

    this.zoom += amount;
    
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/dialog-pdf/dialog.component.ts